import { createPortal } from "react-dom"
import anime from "animejs"
import { useEffect, useImperativeHandle, useRef, useState } from "react"


export default React.forwardRef(({ children, modalTriggerRef, onOpen, onClose, className }, ref) => {
	const [exiting, setExiting] = useState(false)
	const [isOpen, setIsOpen] = useState(false)
	const [isLoading, setIsLoading] = useState(false)

	const overlayRef = useRef(null)
	const modalWrapperRef = useRef(null)
	const modalRef = useRef(null)

	if (!ref) ref = useRef(null)

	const closeModal = () => {
		if (exiting) return
		setExiting(true)

		modalRef.current.classList.remove('animate__fadeIn')
		modalRef.current.classList.add('animate__fadeOut')

		anime({
			targets: overlayRef.current,
			opacity: 0,
			duration: 500,
			easing: 'easeInOutQuad',
			complete: () => {
				setIsOpen(false)
				setExiting(false)
			}
		})
	}

	const openModal = () => {
		setIsOpen(true)
	}

	useImperativeHandle(ref, () => {
		return {
			openModal,
			closeModal,
			setIsLoading,
			isOpen,
		}
	})

	useEffect(() => {
		if (isOpen) {
			anime({
				targets: overlayRef.current,
				opacity: 0.5,
				duration: 200,
				easing: 'easeInOutQuad'
			})
			if (onOpen) onOpen()
		} else {
			if (onClose) onClose()
		}
	}, [isOpen])

	useEffect(() => {
		modalTriggerRef?.current?.addEventListener('click', () => {
			openModal()
		})
	}, [modalTriggerRef])

	return (
		isOpen && createPortal(
			<>
				<div className="absolute top-0 left-0 opacity-0 bg-[#000000] z-20 h-full w-full" ref={overlayRef} onClick={closeModal}>
				</div>
				<div className="modal__wrapper" ref={modalWrapperRef}>
					<div className="modal animate__animated animate__fadeIn" ref={modalRef}>
						<span className="material-symbols-rounded modal__close" onClick={closeModal}>close</span>
						<div className="modal__content">
							{!isLoading &&
								<div className={className}>
									{children}
								</div>
							}

							{isLoading && <div class="lds-ring spinner">
								<div></div>
								<div></div>
								<div></div>
								<div></div>
							</div>}
						</div>
					</div>
				</div>
			</>
			,
			document.body
		)
	)
})